import React from "react";
import { cn } from "@/lib/utils";
import { useReveal } from "@/hooks/useReveal";

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  /** Stagger in milliseconds */
  delay?: number;
  as?: "div" | "section" | "li" | "span";
}

/**
 * Gentle fade + rise on scroll. Falls back to instant visibility
 * when the visitor prefers reduced motion.
 */
export const Reveal = ({ children, className, delay = 0, as = "div" }: RevealProps) => {
  const { ref, visible } = useReveal<HTMLDivElement>();
  const Tag = as as React.ElementType;

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={cn(
        "transition-all duration-700 ease-out will-change-transform motion-reduce:transition-none",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6",
        className
      )}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
